import Color from 'color'
import { useSelector } from 'react-redux'

export const useColor = (colorId?: number) => {
  return useSelector<any, string | undefined>(state => colorId !== undefined ? state.kanbo.branding.colors[colorId] : undefined)
}

export const useForegroundColor = (colorId?: number) => {
  const color = useColor(colorId)

  return Color(color).mix(Color('#eceff1'), 0.6).rgb().string()
}

export const useBackgroundColor = (colorId?: number) => {
  const color = useColor(colorId)

  return Color(color).mix(Color('#eceff1'), 0.8).rgb().string()
}

